import React from 'react';

export const IconNote: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <rect x="3.3" y="1.5" width="1.4" height="13" rx="0.7" fill="currentColor" />
        <path d="M4.7 2.1L12.8 4.3L4.7 6.9V2.1Z" fill="currentColor" />
    </svg>
);
